import { Injectable } from '@angular/core';
import { where } from '@angular/fire/firestore';
import { IService } from '@scandium-oy/ngx-scandium';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Instruction } from '../models/instruction.model';
import { Roles } from '../utility/role';
import { ClientsService } from './clients.service';
import { FirestoreService } from './firestore.service';
import { UsersService } from './users.service';

const itemCollection = 'instructions';

@Injectable({
  providedIn: 'root',
})
export class InstructionsService implements IService<Instruction> {
  constructor(
    private clientsService: ClientsService,
    private firestore: FirestoreService,
    private usersService: UsersService,
  ) { }

  async save(item: Instruction) {
    if (this.clientsService.clientS() != null) {
      item.client = this.clientsService.clientS().guid;
    }
    return this.firestore.save(itemCollection, item);
  }

  async update(item: Instruction) {
    return this.firestore.update(itemCollection, item);
  }

  async delete(item: Instruction) {
    return this.firestore.softDelete(itemCollection, item);
  }

  get(guid: string): Observable<Instruction> {
    return this.firestore.get<Instruction>(itemCollection, guid);
  }

  getList(options?: { site?: string; client?: string; hasSite?: boolean }): Observable<Instruction[]> {
    const queryConstraints = [];
    if (options?.site) {
      queryConstraints.push(where('site', '==', options.site));
    }
    if (options?.client || this.clientsService.clientS() != null) {
      queryConstraints.push(where('client', '==', options?.client ?? this.clientsService.clientS().guid));
    }
    return this.firestore
      .getList<Instruction>(itemCollection, undefined, queryConstraints).pipe(
        map((items) => items?.filter((it) => it.deleted == null) ?? []),
        map((items) => items.filter((it) => options?.hasSite ? it.site != null : true)),
        map((items) => items.filter((it) =>
          [Roles.resident].includes(this.usersService.currentUserS().role) && it.site != null ? this.usersService.currentUserS().worksites.includes(it.site.guid) : true)),
      );
  }
}
